import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Header } from "../components/Layout";
import { http, errMsg, login } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await http.post("/auth/reset-password", { token: params.get("token") || "", password: pw });
      toast.success("Password updated. Please log in.");
      navigate("/");
      setTimeout(login, 300);
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#F4F6F9]">
      <Header />
      <form onSubmit={submit} className="max-w-md mx-auto mt-16 bg-white rounded-2xl border p-8 space-y-3" data-testid="reset-password-form">
        <h1 className="font-heading text-2xl font-bold">Choose a new password</h1>
        <input data-testid="reset-password-input" type="password" required minLength={8} placeholder="New password (min 8 characters)" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-[#EC5B24]" />
        <input data-testid="reset-password-confirm" type="password" required minLength={8} placeholder="Confirm new password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-[#EC5B24]" />
        <button data-testid="reset-password-submit" disabled={busy} className="w-full rounded-xl bg-[#EC5B24] text-white font-bold py-3 flex items-center justify-center gap-2">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update password
        </button>
      </form>
    </div>
  );
}
